import { app } from '../../app.module'
/**
 * アカウントグローバルフォーム
 * @class AccountGlobalFormCtrl
 */
class AccountGlobalFormCtrl {
  private accountGlobalList: {
    value: string
    key: number | string
  }[]
  private accountGlobal: number
  private onChange: Function

  /**
   * 初期化イベント
   */
  public $onInit() {
    // アカウントグローバルの初期化
    this.initAccountGlobalList()
    // アカウントグローバルをしている場合は、アカウントグローバルを変更する
    if (this.accountGlobal) {
      this.changeAccountGlobal()
    }
  }

  /**
   * アカウントグローバルの変更
   */
  public changeAccountGlobal() {
    if (typeof this.onChange === 'function') {
      this.onChange({ accountGlobal: this.accountGlobal })
    }
  }

  /**
   * アカウントグローバル一覧の初期化
   * @return {void}
   */
  private initAccountGlobalList(): void {
    this.accountGlobalList = [
      {
        key: -1,
        value: '指定しない',
      },
      {
        key: 1,
        value: '指定する',
      },
      {
        key: 0,
        value: '除外する',
      },
    ]
  }
}

/**
 * アカウントグローバルフォーム
 * attr: {number} accountGlobal 選択しているアカウントグローバル
 * attr: {function} onChange アカウントグローバルの変更イベント
 */
app.component('accountGlobalForm', {
  bindings: {
    accountGlobal: '<',
    onChange: '&',
  },
  template: require('./account-global-form.pug')(),
  controller: AccountGlobalFormCtrl,
})
